import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "modal-footer" };
const _hoisted_2 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["BModal"], {
            ref: "addTenant",
            "no-footer": "",
            centered: "",
            size: "lg",
            title: _ctx.$t('JTADM_TENANTS_CREATE_TENANT')
        }, {
            default: _withCtx(() => [
                _createVNode($setup["TenantForm"], {
                    tenant: $setup.tenant,
                    "onUpdate:tenant": _cache[0] || (_cache[0] = ($event) => (($setup.tenant) = $event)),
                    "onUpdate:invalid": _cache[1] || (_cache[1] = (value) => ($setup.invalid = value))
                }, null, 8, ["tenant"]),
                _createElementVNode("footer", _hoisted_1, [
                    _createElementVNode("button", {
                        class: "btn btn-info text-white",
                        type: "submit",
                        disabled: $setup.invalid || !Object.keys($setup.tenant).includes('name'),
                        onClick: _withModifiers($setup.addSubmit, ["prevent"])
                    }, _toDisplayString(_ctx.$t('JTADM_TENANTS_CREATE')), 9, _hoisted_2),
                    _createElementVNode("button", {
                        class: "btn btn-danger",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event) => ($setup.addTenant?.hide()))
                    }, _toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                ])
            ]),
            _: 1
        }, 8, ["title"])
    ]));
}
